import Card from "app/components/Card";
import { Skeleton } from "app/components/Skeleton";
import React from "react";

export default function TilesSkeleton() {
  return (
    <Card className="flex flex-col gap-2.5 border border-gray-100">
      {/* Header */}
      <div className="flex gap-2 items-center">
        <Skeleton className="h-5 w-5 rounded" /> {/* icon */}
        <Skeleton className="h-4 w-24 rounded" /> {/* title */}
      </div>

      {/* Ticket types row */}
      <div className="flex justify-between items-center">
        <Skeleton className="h-3 w-20 rounded" /> {/* "Ticket types" */}
        <div className="flex gap-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center gap-1">
              <Skeleton className="h-4 w-4 rounded" />
              <Skeleton className="h-3 w-6 rounded" />
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
